'use client';

import { convertUploadUrl } from '@/lib/upload-utils';
import Image from 'next/image';
import { useState } from 'react';

interface UploadImageProps {
  src: string | null | undefined;
  alt: string;
  width?: number;
  height?: number;
  fill?: boolean;
  className?: string;
  sizes?: string;
  priority?: boolean;
  onError?: () => void;
}

/**
 * Enhanced Image component that automatically converts upload URLs for production compatibility
 * and provides fallback handling for broken images
 */
export const UploadImage = ({
  src,
  alt,
  width,
  height,
  fill,
  className,
  sizes,
  priority,
  onError
}: UploadImageProps) => {
  const [hasError, setHasError] = useState(false);
  const convertedSrc = convertUploadUrl(src);

  // If no valid src or error occurred, don't render
  if (!convertedSrc || hasError) {
    return null;
  }

  const handleError = () => {
    setHasError(true);
    onError?.();
  };

  const commonProps = {
    className,
    sizes,
    priority,
    onError: handleError
  };

  if (fill) {
    return <Image src={convertedSrc} alt={alt} fill {...commonProps} />;
  }

  return (
    <Image src={convertedSrc} alt={alt} width={width || 0} height={height || 0} {...commonProps} />
  );
};
